export type { SandboxOp, SandboxOpEntry, ValidateResult } from '@atlas-manifest/sandboxOps';
export { normalizeSandboxOps, validateOp, applyOps, MAX_STRING_LEN } from '@atlas-manifest/sandboxOps';

import type { Entity, Field } from '@atlas-manifest/types';

export interface EntityDiff {
  added: Field[];
  removed: Field[];
  changed: Array<{ name: string; beforeType: string; afterType: string }>;
}

/** Compare two versions of the same entity field-by-field. */
export function diffEntity(before: Entity, after: Entity): EntityDiff {
  const beforeByName = new Map(before.fields.map((f) => [f.name, f]));
  const afterByName = new Map(after.fields.map((f) => [f.name, f]));
  const added: Field[] = [];
  const removed: Field[] = [];
  const changed: EntityDiff['changed'] = [];

  for (const [name, field] of afterByName) {
    const prev = beforeByName.get(name);
    if (!prev) {
      added.push(field);
    } else if (prev.type !== field.type) {
      changed.push({ name, beforeType: prev.type, afterType: field.type });
    }
  }
  for (const [name, field] of beforeByName) {
    if (!afterByName.has(name)) removed.push(field);
  }
  return { added, removed, changed };
}
